export default "__VITE_ASSET__CeNqduib__"